import { useEffect } from 'react'
import { INTERSECTION_OBSERVER_CONFIG } from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/GiveawayTabs/constants'
import type { TabData } from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/GiveawayTabs/types'
import { GiveawayTabEnum } from '@/views/PreSales/PreSalesGiveawayView/config'

export const useIntersectionObserver = (
  enabled: boolean,
  refs: Partial<Record<GiveawayTabEnum, React.RefObject<HTMLDivElement>>>,
  tabs: TabData[],
  onActiveChange: (type: GiveawayTabEnum) => void,
) => {
  useEffect(() => {
    if (!enabled) return

    const observer = new IntersectionObserver((entries) => {
      const visibleEntry = entries.find((entry) => entry.isIntersecting)
      if (!visibleEntry) return

      const matchingTab = tabs.find((tab) => refs[tab.type]?.current === visibleEntry.target)

      if (matchingTab) {
        onActiveChange(matchingTab.type)
      }
    }, INTERSECTION_OBSERVER_CONFIG)

    Object.values(refs).forEach((ref) => {
      if (ref?.current) {
        observer.observe(ref.current)
      }
    })

    return () => observer.disconnect()
  }, [enabled, refs, tabs, onActiveChange])
}
